export function assert(assertion: boolean, reason: string): asserts assertion {
  if (assertion === false) {
    throw new Error(`Expected ${assertion} to be true: ${reason}`);
  }
}

export function assertUnreachable(_input?: never, reason?: string): never {
  throw new Error(reason ?? 'This path should be unreachable');
}

export function assertExists<T>(obj: T | null | undefined, reason: string): asserts obj is T {
  if (obj === null || obj === undefined) {
    throw new Error(`Expected passed in value to exist: ${reason}`);
  }
}

export function assertMaxLength<T>(arr: Array<T> | string, max: number, reason: string) {
  if (arr.length > max) {
    throw new Error(
      `Expected length of passed in value to be less than or equal to ${max}: ${reason}`
    );
  }
}
